module.exports = __webpack_public_path__ + "img/up1.9b2c4d36.png";